import { render, staticRenderFns } from "./LmFeaturesBuilder.vue?vue&type=template&id=5979d005"
import script from "./LmFeaturesBuilder.vue?vue&type=script&lang=js"
export * from "./LmFeaturesBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports